import React from 'react';
import "./Description.css"
import hr from "./hr.png"
import vc from "./video_canvas.png"
function Description() {
    return (
        <div className={"sec-background"}>
            <div className={"transbox"}>
                <div className={'transbox-text'}>
                    <div className={"text1"}>Παρατηρητήριο Οδικής Ασφάλειας</div>
                    <div className={"text2"}>
                        Το Παρατηρητήριο Οδικής Ασφάλειας DEAR (roaD accidEnts informAtion centeR for Greece), δημιουργήθηκε στο πλαίσιο της Ερευνητικής Υποδομής <a href="https://www.enirisst.gr/" target={'_blank'}>EN.I.R.I.S.S.T.</a> (Intelligent Research Infrastructure, Shipping, Supply Chain, Transport and Logistics) και συγκεκριμένα της <a href="https://www.enirisst.gr/?page_id=2504&lang=el" target={'_blank'}>«Πλατφόρμας Επιβατικών Μετακινήσεων»</a>.
                    </div>
                    <div className={"text2"}>
                        Εδώ μπορείς να βρεις ποικίλα δεδομένα για την οδική ασφάλεια στην Ελλάδα, να παρακολουθήσεις την εξέλιξη τους μέσα στον χρόνο, τα χαρακτηριστικά ανάλογα με το γεωγραφικό τους επίπεδο (Επικράτεια, NUTS 3, Καλλικρατικοί Δήμοι, Οικισμοί), και να τα απεικονίσεις σε διαδραστικούς χάρτες, πίνακες και διαγράμματα. 
                    </div>
                    <div className={"text2"}>
                    Δείτε το βίντεο για μια σύντομη ξενάγηση στην πλατφόρμα μας.
                    </div>
                </div>
                <div className={"video_div"}>
                    <img src={vc} alt={"Video Canvas"} className={"sec-background--top"}/>
                </div>
            </div>
        </div>
    )
}

export default Description;